module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-shadow-10.5da8b6c4.png";